const getDate = (date: string | Date) => {
  // For given value of any date, it converts to local time.
  const d = new Date(date);
  d.setTime(d.getTime() + d.getTimezoneOffset() * 60000);
  return d;
};

export default getDate;
